// extracted by mini-css-extract-plugin
export var menuItem = "P_v0 d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "P_v1 d_Z d_bz d_bP";
export var menuMainLink = "P_v2 d_f0 d_dB";
export var menuLink = "P_v3 d_f0 d_dB";
export var icon = "P_p9 d_bC d_bP";
export var divider = "P_v4 d_bC d_bP";
export var sublinks = "P_v5";
export var link = "P_mC";
export var Link = "P_t0 J_t0 J_tv J_tQ";